import { SxProps, Theme } from "@mui/material";
import { mergeSx } from "merge-sx";

export default function withSx<ComponentProps extends { sx?: SxProps<Theme> }>(
  Component: React.ComponentType<ComponentProps>,
  sxProps: SxProps<Theme>
) {
  function Wrapper(props: ComponentProps) {
    return <Component {...props} sx={mergeSx(sxProps, props.sx)} />;
  }
  Wrapper.displayName = `sx(${Component.displayName})`;
  return Wrapper;
}
